import { FC } from "react";
import { Box, HStack, IconProps, RadioProps, Text, useRadio } from "@chakra-ui/react";

type Props = RadioProps & { value: string, icon?: FC };

export const RadioCard: FC<Props> = ({ icon, children, size, ...rest }) => {
  const { getInputProps, getCheckboxProps, state: { isChecked } } = useRadio(rest);
  const input = getInputProps();
  const checkbox = getCheckboxProps();

  const IconComponent: FC<IconProps> = icon || null;

  return (
    <Box as="label">
      <input {...input} />
      <Box {...checkbox} layerStyle={"radio-card"}>
        <HStack spacing={2} justifyContent={"center"}>
          {icon ? (
            <IconComponent layerStyle={isChecked ? "radio-card-icon--active": "radio-card-icon"} />
          ) : null}
          <Text fontSize={"sm"} fontWeight={500} color={"inherit"}>{children}</Text>
        </HStack>
      </Box>
    </Box>
  )
};
